import { render } from "./OrgApplicationHandlingPanel.vue?vue&type=template&id=56b0de15"
import script from "./OrgApplicationHandlingPanel.vue?vue&type=script&lang=js"
export * from "./OrgApplicationHandlingPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__